/**
 * The profile a climb's page was opened from — a tile of its sends or of the
 * climbs it put up — carried in the router's history state, so the climb page
 * can lead its breadcrumb with the way back to it.
 */
export interface ProfileOrigin {
  slug: string;
  name: string;
  avatarUrl?: string | null;
}

/** The history state a profile's tile opens a climb with. */
export function fromProfileState(profile: ProfileOrigin): { fromProfile: ProfileOrigin } {
  return { fromProfile: profile };
}

/** The profile a page was opened from, if it was; null for any other way in. */
export function profileOrigin(state: unknown): ProfileOrigin | null {
  const profile = (state as { fromProfile?: ProfileOrigin } | null)?.fromProfile;
  return profile?.slug ? profile : null;
}
